import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StandardCalculationInsuredSumComponent } from '../general-calculator/standard-calculation-insured-sum/standard-calculation-insured-sum.component';
import { StandardCalculationPremiumComponent } from '../general-calculator/standard-calculation-premium/standard-calculation-premium.component';
import { AdutCalculationInsuredSumComponent } from '../general-calculator/adut-calculation-insured-sum/adut-calculation-insured-sum.component';
import { AdutCalculationPremiumComponent } from '../general-calculator/adut-calculation-premium/adut-calculation-premium.component';
import { SecurityCalculationInsuredSumComponent } from '../general-calculator/security-calculation-insured-sum/security-calculation-insured-sum.component';
import { SecurityCalculationPremiumComponent } from '../general-calculator/security-calculation-premium/security-calculation-premium.component';
import { SecurityCreditComponent } from '../general-calculator/security-credit/security-credit.component';
import { ScholarshipCalculationInsuredSumComponent } from '../general-calculator/scholarship-calculation-insured-sum/scholarship-calculation-insured-sum.component';
import { ScholarshipCalculationPremiumComponent } from '../general-calculator/scholarship-calculation-premium/scholarship-calculation-premium.component';
import { GoldenAutumnComponent } from '../general-calculator/golden-autumn/golden-autumn.component';
import { NajlifeInsuredSumComponent } from '../general-calculator/najlife-insured-sum/najlife-insured-sum.component';
import { NajlifePremiumComponent } from '../general-calculator/najlife-premium/najlife-premium.component';
import { ProgresiveComponent } from '../general-calculator/progresive/progresive.component';
import { SecurityCashComponent } from '../general-calculator/security-cash/security-cash.component';
import { VipStandardInsuranceSumComponent } from '../general-calculator/vip-standard-insurance-sum/vip-standard-insurance-sum.component';
import { VipStandardPremiumComponent } from '../general-calculator/vip-standard-premium/vip-standard-premium.component';
import { VipSecurityInsuredSumComponent } from '../general-calculator/vip-security-insured-sum/vip-security-insured-sum.component';
import { VipSecurityPremiumComponent } from '../general-calculator/vip-security-premium/vip-security-premium.component';
import { VipScholarshipInsuredSumComponent } from '../general-calculator/vip-scholarship-insured-sum/vip-scholarship-insured-sum.component';
import { VipScholarshipPremiumComponent } from '../general-calculator/vip-scholarship-premium/vip-scholarship-premium.component';


const routes: Routes = [
  {
    path: 'standard-calculation-insured-sum',
    component: StandardCalculationInsuredSumComponent
  },
  {
    path: 'standard-calculation-premium',
    component: StandardCalculationPremiumComponent
  },
  {
    path: 'adut-calculation-insured-sum',
    component: AdutCalculationInsuredSumComponent
  },
  {
    path: 'adut-calculation-premium',
    component: AdutCalculationPremiumComponent
  },
  {
    path: 'security-calculation-insured-sum',
    component: SecurityCalculationInsuredSumComponent
  },
  {
    path: 'security-calculation-premium',
    component: SecurityCalculationPremiumComponent
  },
  {
    path: 'security-credit',
    component: SecurityCreditComponent
  },
  {
    path: 'security-cash',
    component: SecurityCashComponent
  },
  {
    path: 'scholarship-calculation-insured-sum',
    component: ScholarshipCalculationInsuredSumComponent
  },
  {
    path: 'scholarship-calculation-premium',
    component: ScholarshipCalculationPremiumComponent
  },
  {
    path: 'golden-autumn',
    component: GoldenAutumnComponent
  },
  {
    path: 'naj-life-calculation-insured-sum',
    component: NajlifeInsuredSumComponent
  },
  {
    path: 'naj-life-calculation-premium',
    component: NajlifePremiumComponent
  },
  {
    path: 'progresive',
    component: ProgresiveComponent
  },
  {
    path: 'vip-standard-insurance-sum',
    component: VipStandardInsuranceSumComponent
  },
  {
    path: 'vip-standard-premium',
    component: VipStandardPremiumComponent
  },
  {
    path: 'vip-security-insurance-sum',
    component: VipSecurityInsuredSumComponent
  },
  {
    path: 'vip-security-premium',
    component: VipSecurityPremiumComponent
  },
  {
    path: 'vip-scholarship-insurance-sum',
    component: VipScholarshipInsuredSumComponent
  },
  {
    path: 'vip-scholarship-premium',
    component: VipScholarshipPremiumComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalculatorsRoutingModule { }
